import { Device } from "../schemas/device.schema";

export type ModalType = "NONE" | "ADD_NEW_DEVICE" | "EXISTING_DEVICE";

export type ModalState = { activeModal: ModalType; modalData?: Device };

export type ModalAction =
  | { type: "OPEN"; modal: ModalType; payload?: Device }
  | { type: "CLOSE" };

export const modalReducer = (
  state: ModalState,
  action: ModalAction
): ModalState => {
  switch (action.type) {
    case "OPEN":
      return { activeModal: action.modal, modalData: action.payload };
    case "CLOSE":
      return { activeModal: "NONE", modalData: undefined };
    default:
      return state;
  }
};
